module.exports = __webpack_public_path__ + "static/big-symbol-468a1402d3e158a0b581ea6fc3d5329e.png";